module.exports = __webpack_public_path__ + "img/rabbit-running.0897e90d.svg";